/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ItauCobrancaCalendarioResponse } from './itauCobrancaCalendarioResponse';
import { ItauCobrancaDevedor } from './itauCobrancaDevedor';
import { ItauCobrancaInfoAdicional } from './itauCobrancaInfoAdicional';
import { ItauCobrancaPixResponse } from './itauCobrancaPixResponse';
import { ItauLocCobranca } from './itauLocCobranca';
import { ItauValorCobranca } from './itauValorCobranca';

export interface ItauCobrancaResponse {
  calendario?: ItauCobrancaCalendarioResponse;
  chave?: string;
  devedor?: ItauCobrancaDevedor;
  infoAdicionais?: Array<ItauCobrancaInfoAdicional>;
  loc?: ItauLocCobranca;
  location?: string;
  pix?: Array<ItauCobrancaPixResponse>;
  pixCopiaECola?: string;
  revisao?: number;
  solicitacaoPagador?: string;
  status?: ItauCobrancaResponse.StatusEnum;
  txid?: string;
  valor?: ItauValorCobranca;
}
export namespace ItauCobrancaResponse {
  export type StatusEnum =
    | 'ATIVA'
    | 'CONCLUIDA'
    | 'REMOVIDA_PELO_USUARIO_RECEBEDOR'
    | 'REMOVIDA_PELO_PSP';
  export const StatusEnum = {
    ATIVA: 'ATIVA' as StatusEnum,
    CONCLUIDA: 'CONCLUIDA' as StatusEnum,
    REMOVIDAPELOUSUARIORECEBEDOR:
      'REMOVIDA_PELO_USUARIO_RECEBEDOR' as StatusEnum,
    REMOVIDAPELOPSP: 'REMOVIDA_PELO_PSP' as StatusEnum
  };
}
